export default [
  {value: 'open', label: 'Open'},
  {value: 'closed', label: 'Closed'},
];
